export function phone(input) {
  if (!input) return 'N/A';

  const phone = input.replace(/[^\d]/g, '');
  // For all 11-digit phone numbers, return the phone number in this format: 1-604-123-4567
  if (phone.length === 11) {
    return phone.replace(/(\d{1})(\d{3})(\d{3})(\d{4})/, '$1-$2-$3-$4');
  } else if (phone.length === 10) {
  // For all 10-digit phone numbers, return the phone number in this format: 604-123-4567
    return phone.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
  }
  return input;
}
